import styles from './Navigation.module.scss';
import { useMemo, type ReactNode } from 'react';
import { NavigationContext } from './NavigationContext';
import clsx from 'clsx';

interface Props {
  children: ReactNode;
  inline?: boolean;
  outlined?: boolean;
}

export function Navigation({ children, inline = false, outlined }: Props) {
  const navigationContextValue = useMemo(() => ({ inline }), []);
  const className = clsx(styles['root'], outlined && styles['outlined']);
  const ulClassName = clsx(inline && styles['inline']);

  return (
    <NavigationContext value={navigationContextValue}>
      <nav className={className}>
        <ul className={ulClassName}>{children}</ul>
      </nav>
    </NavigationContext>
  );
}
